import React from 'react';
import MRichtext from "./m_richtext"

const EpMehrAnzeigen = (props) => {
  return (
    <MRichtext
      data={{
        text: props.data.epaper_show_more.map(more => more.epaper_show_more_elements.map(el => el.text)).join('')
      }}
      >
    </MRichtext>
  )
}

export default EpMehrAnzeigen;